import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  CardContent,
  Fab,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  MenuItem,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { Search } from "@material-ui/icons";
import {
  ExcelExport,
  ExcelExportColumn,
  ExcelExportColumnGroup,
} from "@progress/kendo-react-excel-export";
import _, { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React from "react";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import SelectAutoComplete from "../../components/SelectAutoComplete";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as agentAction } from "../../redux/agent";
import { mapActionsToProps as campaignAction } from "../../redux/campaigns";
import { mapActionsToProps } from "../../redux/report/campaign";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
  toolbar: {
    paddingLeft: theme.spacing.unit,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f2f2f2",
    },
    "&:last-child": {
      backgroundColor: "#d9d9d9",
    },
  },
  head: {
    backgroundColor: "#f2f2f2",
    position: "sticky",
    top: 65,
    zIndex: 1,
  },
  button: {
    width: "40px",
    height: "40px",
    float: "right",
    marginTop: "-55px",
    fontSize: "16px",
  },
  fab: {
    marginRight: 10,
  },
});

class ReportData extends React.Component {
  state = {
    value: 0,
    filters: {
      order: "createdAt DESC",
      where: {
        gte: null,
        lte: null,
      },
      page: 0,
      pageSize: 20,
    },
    selectReport: "reportDataByGroup",
    listCampaign: [],
    selectedCampaign: "",
  };

  async componentDidMount() {
    this.history = globalHistory();
    this.itemInit();
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.listCampaign)) !==
        JSON.parse(JSON.stringify(_.values(props.listCampaign))) &&
      !state.listCampaign
    ) {
      return {
        listCampaign: _.values(props.listCampaign),
      };
    }
    return null;
  }

  itemInit() {
    const id = this.props.match.params.id;
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "campaignId":
            case "agentGroupId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key === "gte") {
                  and.push({ time: { gte: this.state.filters.where.gte } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.lte } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getAllCampaigns();
    this.props.getListGroupAgent(filters.order, 999, null, null);
  }

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    if (this.state.selectedCampaign) {
      filters.where["campaignId"] = this.state.selectedCampaign;
    } else {
      delete filters.where["campaignId"];
    }
    this.setState({ disable: false });
    let gte = datetimeHelper.toFormat(
      this.state.filters.where.gte,
      "YYYY-MM-DD startDay"
    );
    let lte = datetimeHelper.toFormat(
      this.state.filters.where.lte,
      "YYYY-MM-DD endDay"
    );
    switch (this.state.selectReport) {
      case "reportDataByDay": {
        this.props.campaignReportByDate(gte, lte, filters.where.campaignId);
        break;
      }
      case "reportDataByGroup": {
        this.props.campaignReportByAgent(
          gte,
          lte,
          filters.where.campaignId,
          filters.where.agentGroupId
        );
        break;
      }
      default:
        break;
    }
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD");
    this.setState({ lte });
  };

  handleChange = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  _export;
  export = () => {
    this._export.save();
  };

  filterCustomers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              item &&
              item.name &&
              item.name.toLowerCase().includes(search.toLowerCase())
          )
        : array;
    }
    return array;
  };

  handleSearchUser = (text) => {
    const { listCampaign } = this.props;
    this.setState({
      listCampaign: this.filterCustomers(_.values(listCampaign), text),
    });
  };

  render() {
    const {
      classes,
      listCampaignByAgent,
      listCampaignByDate,
      listAgentGroups,
      listCampaign,
      listCampaignConnectedRateByHour,
      campaignDetail,
      listCampaignReportByStage,
    } = this.props;
    const { filters } = this.state;
    const listCampaignByAgentResult =
      typeof listCampaignByAgent === "object"
        ? Object.keys(listCampaignByAgent).map(
            (key) => listCampaignByAgent[key]
          )
        : listCampaignByAgent;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    const dataReportByAgent = [
      [
        "Mã nhân viên",
        "Mới",
        "Tiềm năng",
        "Cần gọi lại",
        "Không có nhu cầu",
        "Không làm phiền",
        "Không đủ điều kiện",
        "Sai khu vực",
        "Voice mail",
      ],
    ];
    const listAgentGroupsResult =
      typeof listAgentGroups === "object"
        ? Object.keys(listAgentGroups).map((key) => listAgentGroups[key])
        : listAgentGroups;
    const listCampaignByDateResult =
      typeof listCampaignByDate === "object"
        ? Object.keys(listCampaignByDate).map((key) => listCampaignByDate[key])
        : listCampaignByDate;
    let stageMap = [];
    for (const key in listCampaignByAgentResult) {
      if (listCampaignByAgentResult.hasOwnProperty(key)) {
        const value = listCampaignByAgentResult[key];
        if (value.agent.agentCode !== "Total") {
          dataReportByAgent.push([
            value.agent.agentCode,
            value.new,
            value.ptp,
            value.callback,
            value.ni,
            value.dnd,
            value.nmq,
            value.wr,
            value.vm,
          ]);
        }
        stageMap = value.stageMap;
      }
    }

    let reportByGroup = true;
    let reportByDay = false;
    switch (this.state.selectReport) {
      case "reportDataByDay": {
        reportByGroup = false;
        reportByDay = true;
        break;
      }
      case "reportDataByGroup": {
        reportByGroup = true;
        reportByDay = false;
        break;
      }
      default:
        break;
    }

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={2}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Chọn báo cáo"
                          variant="outlined"
                          className={classes.input}
                          value={this.state.selectReport}
                          onChange={this.handleChange("selectReport")}
                          name="selectReport"
                          InputLabelProps={{
                            shrink: true,
                          }}>
                          <MenuItem value="reportDataByDay">
                            Báo cáo dữ liệu theo ngày
                          </MenuItem>
                          <MenuItem value="reportDataByGroup">
                            Báo cáo dữ liệu theo team
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid item md={2} style={{ marginTop: "17px" }}>
                        <SelectAutoComplete
                          label={"Tên chiến dịch"}
                          data={
                            this.state.listCampaign &&
                            this.state.listCampaign.length > 0
                              ? this.state.listCampaign.map((val) => {
                                  return {
                                    id: val.id,
                                    label: val.name ? `${val.name}` : "",
                                  };
                                })
                              : []
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchUser(text),
                            300
                          )}
                          onChange={(item) => {
                            this.setState(
                              {
                                selectedCampaign: item ? item.id : "",
                              },
                              () => {
                                this.handleSubmit();
                              }
                            );
                          }}
                          className={classes.input}
                          onClear={true}
                          name="agentId"
                        />
                      </Grid>
                      <Grid item md={2}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="gte"
                          maxDate={new Date()}
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={2}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.lte}
                          maxDate={new Date()}
                          minDate={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="lte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>

                      {reportByGroup === true ? (
                        <Grid item md={2}>
                          <SelectValidator
                            id="outlined-full-width"
                            margin="normal"
                            label="Team"
                            variant="outlined"
                            className={classes.input}
                            onChange={this.handleSearch}
                            value={filters.where.agentGroupId}
                            name="agentGroupId"
                            InputLabelProps={{
                              shrink: true,
                            }}>
                            <MenuItem>
                              <em>Tất cả</em>
                            </MenuItem>
                            {listAgentGroupsResult
                              ? listAgentGroupsResult.map((item, key) => {
                                  return (
                                    <MenuItem key={key} value={item.id}>
                                      {item.name}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </SelectValidator>
                        </Grid>
                      ) : (
                        <React.Fragment />
                      )}

                      <Grid
                        item
                        md={2}
                        style={{ alignItem: "center", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            // onClick={this.handleSubmit}
                            type="submit"
                            style={{ marginTop: "15px" }}>
                            <Search />
                          </Fab>
                        </Tooltip>
                        <Tooltip title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            style={{ marginTop: "15px" }}
                            className={classes.fab}
                            onClick={this.export}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
                {reportByGroup === true ? (
                  <ExcelExport
                    data={listCampaignByAgentResult}
                    ref={(exporter) => (this._export = exporter)}
                    fileName="Báo cáo dữ liệu theo team.xlsx">
                    <ExcelExportColumn
                      field="date"
                      title="Ngày"
                      locked={true}
                      width={50}
                    />
                    <ExcelExportColumn
                      field="agent.agentGroup"
                      title="Team"
                      locked={true}
                      width={50}
                    />
                    <ExcelExportColumn
                      field="agent.agentCode"
                      title="Mã nhân viên"
                      width={80}
                    />
                    <ExcelExportColumn
                      field="agent.agentFullName"
                      title="Tên nhân viên"
                      width={100}
                    />
                    <ExcelExportColumn
                      field="totalILog"
                      title="Tổng số cuộc gọi kết nối"
                      width={80}
                    />
                    <ExcelExportColumnGroup
                      title="Chưa tương tác"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="new" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenNew"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Đạt điều kiện"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="ptp" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenPtp"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Hẹn gọi lại"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="callback" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenCallback"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Không có nhu cầu"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="ni" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenNi"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Không đủ điều kiện"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="nmq" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenNmq"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Vùng miền"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="wr" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenWr"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Voice mail"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="vm" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenVm"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Không làm phiền"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="dnd" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenDnd"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                  </ExcelExport>
                ) : (
                  <ExcelExport
                    data={listCampaignByDateResult}
                    ref={(exporter) => (this._export = exporter)}
                    fileName="Báo cáo dữ liệu theo ngày.xlsx">
                    <ExcelExportColumn
                      field="date"
                      title="Ngày"
                      locked={true}
                      width={50}
                    />
                    <ExcelExportColumn
                      field="totalILog"
                      title="Tổng số cuộc gọi kết nối"
                      width={80}
                    />
                    <ExcelExportColumnGroup
                      title="Chưa tương tác"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="new" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenNew"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Đạt điều kiện"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="ptp" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenPtp"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Hẹn gọi lại"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="callback" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenCallback"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Không có nhu cầu"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="ni" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenNi"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Không đủ điều kiện"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="nmq" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenNmq"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Vùng miền"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="wr" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenWr"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Voice mail"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="vm" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenVm"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                    <ExcelExportColumnGroup
                      title="Không làm phiền"
                      headerCellOptions={{ textAlign: "center" }}>
                      <ExcelExportColumn field="dnd" title="Tổng số" />
                      <ExcelExportColumn
                        field="percenDnd"
                        title="Tỉ lệ (%)"
                        width={100}
                      />
                    </ExcelExportColumnGroup>
                  </ExcelExport>
                )}
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <Paper square style={{ marginTop: 15 }}>
          {reportByGroup === true ? (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.head}
                    rowSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Ngày
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    rowSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Team
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    rowSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Mã nhân viên
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    rowSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tên nhân viên
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    rowSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số cuộc gọi kết nối
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Chưa tương tác
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Đạt điều kiện
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Hẹn gọi lại
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Không có nhu cầu
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Không đủ điều kiện
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Vùng miền
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Voice Mail
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Không làm phiền
                  </TableCell>
                  {stageMap.length !== 0
                    ? stageMap.map((item, key) => {
                        return (
                          <TableCell
                            colSpan="2"
                            key={key}
                            className={classes.head}
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {item.name}
                          </TableCell>
                        );
                      })
                    : null}
                </TableRow>
                <TableRow>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  {stageMap.length !== 0
                    ? stageMap.map((item, key) => {
                        return (
                          <React.Fragment key={key}>
                            <TableCell
                              className={classes.head}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              Tổng số
                            </TableCell>
                            <TableCell
                              className={classes.head}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              Tỉ lệ (%)
                            </TableCell>
                          </React.Fragment>
                        );
                      })
                    : null}
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: "#fff" }}>
                {listCampaignByAgentResult
                  ? listCampaignByAgentResult.map((row, key) => {
                      return (
                        <TableRow
                          className={classes.row}
                          key={key}
                          style={{ whiteSpace: "nowrap" }}>
                          {row.groups.date.index === 0 ? (
                            <TableCell
                              component="th"
                              scope="row"
                              rowSpan={row.groups.date.count}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              {row.date}
                            </TableCell>
                          ) : (
                            <React.Fragment />
                          )}
                          {row.groups.dateNTeam.index === 0 ? (
                            <TableCell
                              component="th"
                              scope="row"
                              rowSpan={row.groups.dateNTeam.count}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              {row.agent.agentGroup}
                            </TableCell>
                          ) : (
                            <React.Fragment />
                          )}

                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.agentCode}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.agentFullName}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalILog === 0
                              ? "-"
                              : Math.round(row.totalILog)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.new === 0 ? "-" : Math.round(row.new)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenNew) === 0
                              ? "-"
                              : Math.round(row.percenNew)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.ptp === 0 ? "-" : Math.round(row.ptp)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenPtp) === 0
                              ? "-"
                              : Math.round(row.percenPtp)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.callback === 0
                              ? "-"
                              : Math.round(row.callback)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenCallback) === 0
                              ? "-"
                              : Math.round(row.percenCallback)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.ni === 0 ? "-" : Math.round(row.ni)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenNi) === 0
                              ? "-"
                              : Math.round(row.percenNi)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.nmq === 0 ? "-" : Math.round(row.nmq)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenNmq) === 0
                              ? "-"
                              : Math.round(row.percenNmq)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.wr === 0 ? "-" : Math.round(row.wr)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenWr) === 0
                              ? "-"
                              : Math.round(row.percenWr)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.vm === 0 ? "-" : Math.round(row.vm)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenVm) === 0
                              ? "-"
                              : Math.round(row.percenVm)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.dnd === 0 ? "-" : Math.round(row.dnd)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenDnd) === 0
                              ? "-"
                              : Math.round(row.percenDnd)}{" "}
                            %
                          </TableCell>
                          {row.stageMap
                            ? row.stageMap.map((item, key) => {
                                return (
                                  <React.Fragment key={key}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        padding: "4px 4px 4px 4px",
                                        textAlign: "center",
                                      }}>
                                      {item.quantity === 0
                                        ? "-"
                                        : Math.round(item.quantity)}
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        padding: "4px 4px 4px 4px",
                                        textAlign: "center",
                                      }}>
                                      {Math.round(item.percent) === 0
                                        ? "-"
                                        : Math.round(item.percent)}{" "}
                                      %
                                    </TableCell>
                                  </React.Fragment>
                                );
                              })
                            : null}
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          ) : (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.head}
                    rowSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Ngày
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    rowSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số cuộc kết nối
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Chưa tương tác
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Đạt điều kiện
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Hẹn gọi lại
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Không có nhu cầu
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Không đủ điều kiện
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Vùng miền
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Voice Mail
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    colSpan="2"
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Không làm phiền
                  </TableCell>
                  {stageMap.length !== 0
                    ? stageMap.map((item, key) => {
                        return (
                          <TableCell
                            colSpan="2"
                            key={key}
                            className={classes.head}
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {item.name}
                          </TableCell>
                        );
                      })
                    : null}
                </TableRow>
                <TableRow>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tỉ lệ (%)
                  </TableCell>
                  {stageMap.length !== 0
                    ? stageMap.map((item, key) => {
                        return (
                          <React.Fragment key={key}>
                            <TableCell
                              className={classes.head}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              Tổng số
                            </TableCell>
                            <TableCell
                              className={classes.head}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              Tỉ lệ (%)
                            </TableCell>
                          </React.Fragment>
                        );
                      })
                    : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {listCampaignByDateResult
                  ? listCampaignByDateResult.map((row, key) => {
                      return (
                        <TableRow
                          className={classes.row}
                          key={key}
                          style={{ whiteSpace: "nowrap" }}>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.date}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalILog === 0
                              ? "-"
                              : Math.round(row.totalILog)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.new === 0 ? "-" : Math.round(row.new)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenNew) === 0
                              ? "-"
                              : Math.round(row.percenNew)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.ptp === 0 ? "-" : Math.round(row.ptp)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenPtp) === 0
                              ? "-"
                              : Math.round(row.percenPtp)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.callback === 0
                              ? "-"
                              : Math.round(row.callback)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenCallback) === 0
                              ? "-"
                              : Math.round(row.percenCallback)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.ni === 0 ? "-" : Math.round(row.ni)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenNi) === 0
                              ? "-"
                              : Math.round(row.percenNi)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.nmq === 0 ? "-" : Math.round(row.nmq)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenNmq) === 0
                              ? "-"
                              : Math.round(row.percenNmq)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.wr === 0 ? "-" : Math.round(row.wr)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenWr) === 0
                              ? "-"
                              : Math.round(row.percenWr)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.vm === 0 ? "-" : Math.round(row.vm)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenVm) === 0
                              ? "-"
                              : Math.round(row.percenVm)}{" "}
                            %
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.dnd === 0 ? "-" : Math.round(row.dnd)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {Math.round(row.percenDnd) === 0
                              ? "-"
                              : Math.round(row.percenDnd)}{" "}
                            %
                          </TableCell>
                          {row.stageMap
                            ? row.stageMap.map((item, key) => {
                                return (
                                  <React.Fragment key={key}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        padding: "4px 4px 4px 4px",
                                        textAlign: "center",
                                      }}>
                                      {item.quantity === 0
                                        ? "-"
                                        : Math.round(item.quantity)}
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        borderRight:
                                          "1px solid rgba(224, 224, 224, 1)",
                                        padding: "4px 4px 4px 4px",
                                        textAlign: "center",
                                      }}>
                                      {Math.round(item.percent) === 0
                                        ? "-"
                                        : Math.round(item.percent)}{" "}
                                      %
                                    </TableCell>
                                  </React.Fragment>
                                );
                              })
                            : null}
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          )}
        </Paper>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

ReportData.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  campaignDetail: state.reportCampaign.campaignDetail,
  listCampaignByAgent: state.reportCampaign.campaignByAgent,
  listCampaign: state.campaign.allCampaign,
  listAgentGroups: state.agent.groupAgent,
  listCampaignByDate: state.reportCampaign.campaignByDate,
  loading: state.reportCampaign.loading,
});
const AgentAction = connect(null, agentAction)(ReportData);
ReportData = connect(mapStateToProps, mapActionsToProps)(AgentAction);
const CampaignAction = connect(null, campaignAction)(ReportData);

export default withStyles(styles)(CampaignAction);
